// extracted by mini-css-extract-plugin
export default {"popover":"Popover_popover__e-A6K","is-scrollable":"Popover_is-scrollable__Vw+Ci","popover-content":"Popover_popover-content__zRaRE"};